<div class="view-component">
    <div class="view-component-title">
        <span class="title">{{'productsdownload.title'|translateTA}}</span>
    </div>
    <div class="content">
        <div class="main">
            <div class="company">
                <div class="tem-field" *ngIf="uid.user.companylist.length > 1 ">
                    <span class="tem-field-label">{{'productsdownload.chooseCompany'|translateTA}}</span>
                    <nz-select [ngModel]="codecompany" nzShowSearch
                        [nzPlaceHolder]="'productsdownload.chooseCompany'|translateTA"
                        (ngModelChange)="codecompany=$event; enableFilters()">
                        <nz-option *ngFor="let data of uid.user.companylist" [nzValue]="data.codecompany"
                            [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="field" [formGroup]="formInicial">
                <div class="tem-field">
                    <span class="tem-field-label">{{'productsdownload.searchLabel'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="clearSuffix">
                        <input nz-input formControlName="productSearch"
                            [placeholder]="'productsdownload.searchPlaceholder'|translateTA" #inp type="text"
                            (keydown)="inputChanged()" (keyup)="updateFilter($event)"
                            (keydown.enter)="enableSearch && pesquisar(false)">
                    </nz-input-group>
                    <ng-template #clearSuffix>
                        <button type="button" nz-button nzType="text" nzSize="small" nzShape="circle"
                            [disabled]="!enableSearch" (click)="limparBusca()"
                            nz-tooltip [nzTooltipTitle]="'productsdownload.clear'|translateTA">
                            <span nz-icon nzType="close-circle"></span>
                        </button>
                    </ng-template>
                </div>
            </div>
            <div class="buttonicon">
                <span><button type="button" nz-button nzType="primary" (click)="pesquisar(false)"
                        [disabled]="!enableSearch">{{'productsdownload.search'|translateTA}}</button></span>
            </div>
            <div class="radio">
                <label class="switch-label">
                    <nz-switch [ngModel]="updateMode" (ngModelChange)="changeMode($event)"></nz-switch>
                    <span class="switch-text">{{'productsdownload.updateMode'|translateTA}}</span>
                </label>
            </div>
        </div>
        <div class="melicontainer">
            <div [ngClass]="!updateMode ? 'melicontainer left' :'melicontainer left-change-mode'">
                <nz-spin [nzSpinning]="loadingMeli" class="left-spin">
                    <div class="information" [hidden]="!showFilter && !updateMode">
                        <div class="inf" *ngIf="!updateMode"><span>{{'productsdownload.showing'|translateTA}}
                                {{meliItens.length}} {{'productsdownload.of'|translateTA}} {{paging['total']}}
                                {{'productsdownload.results'|translateTA}}</span></div>
                        <div class="inf" *ngIf="updateMode"><span>{{'productsdownload.selectedCount'|translateTA}}
                                {{(meliItens|arrayFilter:'checked':'true':false).length}}
                                {{'productsdownload.of'|translateTA}} {{paging['total'] == null ? 0 : paging['total'] }}
                                {{'productsdownload.results'|translateTA}}</span></div>
                        <div class="action-button" *ngIf="!updateMode">
                            <span><button type="button" nz-button nzType="primary"
                                    (click)="pesquisar(true)">{{'productsdownload.next'|translateTA}}</button></span>
                        </div>
                        <div class="action-button" *ngIf="updateMode">
                            <span><button type="button" nz-button [disabled]="meliItens.length == 0"
                                    (click)="acaoAlterar(true)">
                                    <span nz-icon nzType="check-square"></span>{{'productsdownload.checkAll'|translateTA}}</button></span>
                            <span><button type="button" nz-button nzDanger [disabled]="meliItens.length== 0"
                                    (click)="acaoAlterar(false)">
                                    <span nz-icon nzType="border"></span>{{'productsdownload.uncheckAll'|translateTA}}</button></span>
                            <div class='vl'></div>
                            <span><button type="button" nz-button nzType="primary" [disabled]="meliItens.length== 0"
                                    (click)="processar()">{{'productsdownload.process'|translateTA}}</button></span>
                        </div>
                    </div>
                    <div class="detail">
                        <nz-empty *ngIf="meliTempItens.length === 0" nzNotFoundImage="simple"
                            [nzNotFoundContent]="'productsdownload.empty'|translateTA"></nz-empty>
                        <div class="cards">
                            <div class="card-cell" *ngFor="let meli of meliTempItens">
                                <meli-item [melidata]="meli" (select)="selectProduct($event)"
                                    [codeCompany]="codecompany" *ngIf="!updateMode"></meli-item>
                                <ng-container [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:meli}"
                                    *ngIf="updateMode"></ng-container>
                            </div>
                        </div>
                    </div>
                </nz-spin>
            </div>
            <div class="melicontainer right" *ngIf="!updateMode">
                <div class="top">
                    <div class="accordion-panel-filter">
                        <span class="title">{{'productsdownload.filterPanel'|translateTA}}</span>
                        <div class="body" [hidden]="!showFilter">
                            <nz-collapse>
                                <nz-collapse-panel *ngFor="let c of available_filters" [nzHeader]="c['name']"
                                    [nzExtra]="filterExtra">
                                    <ng-template #filterExtra>
                                        <span nz-icon nzType="filter"
                                            [ngClass]="{'itemselected': isFilterPanelSelected(c)}"></span>
                                    </ng-template>
                                    <div class="filter-option" *ngFor="let d of c['values']"
                                        [ngClass]="{'selected': isFilterSelected(c,d)}" (click)="toggleFilter(c,d)">
                                        <div><b>{{d.name}}</b> - {{d.results}} {{'productsdownload.lines'|translateTA}}</div>
                                    </div>
                                </nz-collapse-panel>
                            </nz-collapse>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="accordion-panel-order">
                        <span class="title">{{'productsdownload.sortPanel'|translateTA}}</span>
                        <div class="body">
                            <nz-collapse *ngIf="showSort">
                                <nz-collapse-panel [nzHeader]="'productsdownload.sort'|translateTA"
                                    [nzExtra]="sortExtra">
                                    <ng-template #sortExtra>
                                        <span nz-icon nzType="sort-ascending"
                                            [ngClass]="{'itemselected': selectedOrder.length > 0}"></span>
                                    </ng-template>
                                    <div class="filter-option" *ngFor="let c of available_sorts"
                                        [ngClass]="{'selected': isSortSelected(c)}" (click)="toggleSort(c)">
                                        <div><b>{{c.name}}</b></div>
                                    </div>
                                </nz-collapse-panel>
                            </nz-collapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #main let-item>

    <div class="update-card">
        <div class="update-card-header">
            <div class="image">
                <rounded-checkbox [(ngModel)]="item.checked" (change)="selectChk($event,item)"></rounded-checkbox>
            </div>
            <div class="title-product" nz-tooltip [nzTooltipTitle]="item.CODEPRODUCT+'-'+item.DESCRPROD">
                <span>{{item.CODEPRODUCT}} - {{item.DESCRPROD}}</span>
            </div>
        </div>
        <div class="update-card-subtitle">{{item.ID}}</div>
    </div>

</ng-template>
